function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @module ol/format/WKT
 */
import Feature from '../Feature.js';
import GeometryCollection from '../geom/GeometryCollection.js';
import LineString from '../geom/LineString.js';
import MultiLineString from '../geom/MultiLineString.js';
import MultiPoint from '../geom/MultiPoint.js';
import MultiPolygon from '../geom/MultiPolygon.js';
import Point from '../geom/Point.js';
import Polygon from '../geom/Polygon.js';
import TextFeature from './TextFeature.js';
import { transformGeometryWithOptions } from './Feature.js';

/**
 * Geometry constructors
 * @enum {function (new:import("../geom/Geometry.js").default, Array, import("../geom/Geometry.js").GeometryLayout)}
 */
var GeometryConstructor = {
  'POINT': Point,
  'LINESTRING': LineString,
  'POLYGON': Polygon,
  'MULTIPOINT': MultiPoint,
  'MULTILINESTRING': MultiLineString,
  'MULTIPOLYGON': MultiPolygon
};

/**
 * @typedef {Object} Options
 * @property {boolean} [splitCollection=false] Whether to split GeometryCollections into
 * multiple features on reading.
 */

/**
 * @typedef {Object} Token
 * @property {number} type Type.
 * @property {number|string} [value] Value.
 * @property {number} position Position.
 */

/**
 * @const
 * @type {string}
 */
var EMPTY = 'EMPTY';

/**
 * @const
 * @type {string}
 */
var Z = 'Z';

/**
 * @const
 * @type {string}
 */
var M = 'M';

/**
 * @const
 * @type {string}
 */
var ZM = 'ZM';

/**
 * @const
 * @enum {number}
 */
var TokenType = {
  START: 0,
  TEXT: 1,
  LEFT_PAREN: 2,
  RIGHT_PAREN: 3,
  NUMBER: 4,
  COMMA: 5,
  EOF: 6
};

/**
 * @type {Object<import("../geom/Geometry.js").Type, string>}
 */
var wktTypeLookup = {
  Point: 'POINT',
  LineString: 'LINESTRING',
  Polygon: 'POLYGON',
  MultiPoint: 'MULTIPOINT',
  MultiLineString: 'MULTILINESTRING',
  MultiPolygon: 'MULTIPOLYGON',
  GeometryCollection: 'GEOMETRYCOLLECTION',
  Circle: 'CIRCLE'
};

/**
 * Class to tokenize a WKT string.
 */
var Lexer = /*#__PURE__*/function () {
  /**
   * @param {string} wkt WKT string.
   */
  function Lexer(wkt) {
    _classCallCheck(this, Lexer);
    /**
     * @type {string}
     */
    this.wkt = wkt;

    /**
     * @type {number}
     * @private
     */
    this.index_ = -1;
  }

  /**
   * @param {string} c Character.
   * @return {boolean} Whether the character is alphabetic.
   * @private
   */
  return _createClass(Lexer, [{
    key: "isAlpha_",
    value: function isAlpha_(c) {
      return c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z';
    }

    /**
     * @param {string} c Character.
     * @param {boolean} [decimal] Whether the string number
     *     contains a dot, i.e. is a decimal number.
     * @return {boolean} Whether the character is numeric.
     * @private
     */
  }, {
    key: "isNumeric_",
    value: function isNumeric_(c, decimal) {
      decimal = decimal !== undefined ? decimal : false;
      return c >= '0' && c <= '9' || c == '.' && !decimal;
    }

    /**
     * @param {string} c Character.
     * @return {boolean} Whether the character is whitespace.
     * @private
     */
  }, {
    key: "isWhiteSpace_",
    value: function isWhiteSpace_(c) {
      return c == ' ' || c == '\t' || c == '\r' || c == '\n';
    }

    /**
     * @return {string} Next string character.
     * @private
     */
  }, {
    key: "nextChar_",
    value: function nextChar_() {
      return this.wkt.charAt(++this.index_);
    }

    /**
     * Fetch and return the next token.
     * @return {Token} Next string token.
     */
  }, {
    key: "nextToken",
    value: function nextToken() {
      var c = this.nextChar_();
      var position = this.index_;
      /** @type {number|string} */
      var value = c;
      var type;
      if (c == '(') {
        type = TokenType.LEFT_PAREN;
      } else if (c == ',') {
        type = TokenType.COMMA;
      } else if (c == ')') {
        type = TokenType.RIGHT_PAREN;
      } else if (this.isNumeric_(c) || c == '-') {
        type = TokenType.NUMBER;
        value = this.readNumber_();
      } else if (this.isAlpha_(c)) {
        type = TokenType.TEXT;
        value = this.readText_();
      } else if (this.isWhiteSpace_(c)) {
        return this.nextToken();
      } else if (c === '') {
        type = TokenType.EOF;
      } else {
        throw new Error('Unexpected character: ' + c);
      }
      return {
        position: position,
        value: value,
        type: type
      };
    }

    /**
     * @return {number} Numeric token value.
     * @private
     */
  }, {
    key: "readNumber_",
    value: function readNumber_() {
      var c;
      var index = this.index_;
      var decimal = false;
      var scientificNotation = false;
      do {
        if (c == '.') {
          decimal = true;
        } else if (c == 'e' || c == 'E') {
          scientificNotation = true;
        }
        c = this.nextChar_();
      } while (this.isNumeric_(c, decimal) ||
      // if we haven't detected a scientific number before, 'e' or 'E'
      // hint that we should continue to read
      !scientificNotation && (c == 'e' || c == 'E') ||
      // once we know that we have a scientific number, both '-' and '+'
      // are allowed
      scientificNotation && (c == '-' || c == '+'));
      return parseFloat(this.wkt.substring(index, this.index_--));
    }

    /**
     * @return {string} String token value.
     * @private
     */
  }, {
    key: "readText_",
    value: function readText_() {
      var c;
      var index = this.index_;
      do {
        c = this.nextChar_();
      } while (this.isAlpha_(c));
      return this.wkt.substring(index, this.index_--).toUpperCase();
    }
  }]);
}();
/**
 * Class to parse the tokens from the WKT string.
 */
var Parser = /*#__PURE__*/function () {
  /**
   * @param {Lexer} lexer The lexer.
   */
  function Parser(lexer) {
    _classCallCheck(this, Parser);
    /**
     * @type {Lexer}
     * @private
     */
    this.lexer_ = lexer;

    /**
     * @type {Token}
     * @private
     */
    this.token_ = {
      position: 0,
      type: TokenType.START
    };

    /**
     * @type {import("../geom/Geometry.js").GeometryLayout}
     * @private
     */
    this.layout_ = 'XY';
  }

  /**
   * Fetch the next token form the lexer and replace the active token.
   * @private
   */
  return _createClass(Parser, [{
    key: "consume_",
    value: function consume_() {
      this.token_ = this.lexer_.nextToken();
    }

    /**
     * Tests if the given type matches the type of the current token.
     * @param {TokenType} type Token type.
     * @return {boolean} Whether the token matches the given type.
     */
  }, {
    key: "isTokenType",
    value: function isTokenType(type) {
      return this.token_.type == type;
    }

    /**
     * If the given type matches the current token, consume it.
     * @param {TokenType} type Token type.
     * @return {boolean} Whether the token matches the given type.
     */
  }, {
    key: "match",
    value: function match(type) {
      var isMatch = this.isTokenType(type);
      if (isMatch) {
        this.consume_();
      }
      return isMatch;
    }

    /**
     * Try to parse the tokens provided by the lexer.
     * @return {import("../geom/Geometry.js").default} The geometry.
     */
  }, {
    key: "parse",
    value: function parse() {
      this.consume_();
      return this.parseGeometry_();
    }

    /**
     * Try to parse the dimensional info.
     * @return {import("../geom/Geometry.js").GeometryLayout} The layout.
     * @private
     */
  }, {
    key: "parseGeometryLayout_",
    value: function parseGeometryLayout_() {
      /** @type {import("../geom/Geometry.js").GeometryLayout} */
      var layout = 'XY';
      var dimToken = this.token_;
      if (this.isTokenType(TokenType.TEXT)) {
        var dimInfo = dimToken.value;
        if (dimInfo === Z) {
          layout = 'XYZ';
        } else if (dimInfo === M) {
          layout = 'XYM';
        } else if (dimInfo === ZM) {
          layout = 'XYZM';
        }
        if (layout !== 'XY') {
          this.consume_();
        }
      }
      return layout;
    }

    /**
     * @return {Array<import("../geom/Geometry.js").default>} A collection of geometries.
     * @private
     */
  }, {
    key: "parseGeometryCollectionText_",
    value: function parseGeometryCollectionText_() {
      if (this.match(TokenType.LEFT_PAREN)) {
        var geometries = [];
        do {
          geometries.push(this.parseGeometry_());
        } while (this.match(TokenType.COMMA));
        if (this.match(TokenType.RIGHT_PAREN)) {
          return geometries;
        }
      }
      throw new Error(this.formatErrorMessage_());
    }

    /**
     * @return {Array<number>} All values in a point.
     * @private
     */
  }, {
    key: "parsePointText_",
    value: function parsePointText_() {
      if (this.match(TokenType.LEFT_PAREN)) {
        var coordinates = this.parsePoint_();
        if (this.match(TokenType.RIGHT_PAREN)) {
          return coordinates;
        }
      }
      throw new Error(this.formatErrorMessage_());
    }

    /**
     * @return {Array<Array<number>>} All points in a linestring.
     * @private
     */
  }, {
    key: "parseLineStringText_",
    value: function parseLineStringText_() {
      if (this.match(TokenType.LEFT_PAREN)) {
        var coordinates = this.parsePointList_();
        if (this.match(TokenType.RIGHT_PAREN)) {
          return coordinates;
        }
      }
      throw new Error(this.formatErrorMessage_());
    }

    /**
     * @return {Array<Array<Array<number>>>} All points in a polygon.
     * @private
     */
  }, {
    key: "parsePolygonText_",
    value: function parsePolygonText_() {
      if (this.match(TokenType.LEFT_PAREN)) {
        var coordinates = this.parseLineStringTextList_();
        if (this.match(TokenType.RIGHT_PAREN)) {
          return coordinates;
        }
      }
      throw new Error(this.formatErrorMessage_());
    }

    /**
     * @return {Array<Array<number>>} All points in a multipoint.
     * @private
     */
  }, {
    key: "parseMultiPointText_",
    value: function parseMultiPointText_() {
      if (this.match(TokenType.LEFT_PAREN)) {
        var coordinates;
        if (this.token_.type == TokenType.LEFT_PAREN) {
          coordinates = this.parsePointTextList_();
        } else {
          coordinates = this.parsePointList_();
        }
        if (this.match(TokenType.RIGHT_PAREN)) {
          return coordinates;
        }
      }
      throw new Error(this.formatErrorMessage_());
    }

    /**
     * @return {Array<Array<Array<number>>>} All linestring points
     *                                          in a multilinestring.
     * @private
     */
  }, {
    key: "parseMultiLineStringText_",
    value: function parseMultiLineStringText_() {
      if (this.match(TokenType.LEFT_PAREN)) {
        var coordinates = this.parseLineStringTextList_();
        if (this.match(TokenType.RIGHT_PAREN)) {
          return coordinates;
        }
      }
      throw new Error(this.formatErrorMessage_());
    }

    /**
     * @return {Array<Array<Array<Array<number>>>>} All polygon points in a multipolygon.
     * @private
     */
  }, {
    key: "parseMultiPolygonText_",
    value: function parseMultiPolygonText_() {
      if (this.match(TokenType.LEFT_PAREN)) {
        var coordinates = this.parsePolygonTextList_();
        if (this.match(TokenType.RIGHT_PAREN)) {
          return coordinates;
        }
      }
      throw new Error(this.formatErrorMessage_());
    }

    /**
     * @return {Array<number>} A point.
     * @private
     */
  }, {
    key: "parsePoint_",
    value: function parsePoint_() {
      var coordinates = [];
      var dimensions = this.layout_.length;
      for (var i = 0; i < dimensions; ++i) {
        var token = this.token_;
        if (this.match(TokenType.NUMBER)) {
          coordinates.push(/** @type {number} */token.value);
        } else {
          break;
        }
      }
      if (coordinates.length == dimensions) {
        return coordinates;
      }
      throw new Error(this.formatErrorMessage_());
    }

    /**
     * @return {Array<Array<number>>} An array of points.
     * @private
     */
  }, {
    key: "parsePointList_",
    value: function parsePointList_() {
      var coordinates = [this.parsePoint_()];
      while (this.match(TokenType.COMMA)) {
        coordinates.push(this.parsePoint_());
      }
      return coordinates;
    }

    /**
     * @return {Array<Array<number>>} An array of points.
     * @private
     */
  }, {
    key: "parsePointTextList_",
    value: function parsePointTextList_() {
      var coordinates = [this.parsePointText_()];
      while (this.match(TokenType.COMMA)) {
        coordinates.push(this.parsePointText_());
      }
      return coordinates;
    }

    /**
     * @return {Array<Array<Array<number>>>} An array of points.
     * @private
     */
  }, {
    key: "parseLineStringTextList_",
    value: function parseLineStringTextList_() {
      var coordinates = [this.parseLineStringText_()];
      while (this.match(TokenType.COMMA)) {
        coordinates.push(this.parseLineStringText_());
      }
      return coordinates;
    }

    /**
     * @return {Array<Array<Array<Array<number>>>>} An array of points.
     * @private
     */
  }, {
    key: "parsePolygonTextList_",
    value: function parsePolygonTextList_() {
      var coordinates = [this.parsePolygonText_()];
      while (this.match(TokenType.COMMA)) {
        coordinates.push(this.parsePolygonText_());
      }
      return coordinates;
    }

    /**
     * @return {boolean} Whether the token implies an empty geometry.
     * @private
     */
  }, {
    key: "isEmptyGeometry_",
    value: function isEmptyGeometry_() {
      var isEmpty = this.isTokenType(TokenType.TEXT) && this.token_.value == EMPTY;
      if (isEmpty) {
        this.consume_();
      }
      return isEmpty;
    }

    /**
     * Create an error message for an unexpected token error.
     * @return {string} Error message.
     * @private
     */
  }, {
    key: "formatErrorMessage_",
    value: function formatErrorMessage_() {
      return 'Unexpected `' + this.token_.value + '` at position ' + this.token_.position + ' in `' + this.lexer_.wkt + '`';
    }

    /**
     * @return {import("../geom/Geometry.js").default} The geometry.
     * @private
     */
  }, {
    key: "parseGeometry_",
    value: function parseGeometry_() {
      var token = this.token_;
      if (this.match(TokenType.TEXT)) {
        var geomType = /** @type {string} */token.value;
        this.layout_ = this.parseGeometryLayout_();
        var isEmpty = this.isEmptyGeometry_();
        if (geomType == 'GEOMETRYCOLLECTION') {
          if (isEmpty) {
            return new GeometryCollection([]);
          }
          var geometries = this.parseGeometryCollectionText_();
          return new GeometryCollection(geometries);
        }
        var ctor = GeometryConstructor[geomType];
        if (!ctor) {
          throw new Error('Invalid geometry type: ' + geomType);
        }
        var coordinates;
        if (isEmpty) {
          if (geomType == 'POINT') {
            coordinates = [NaN, NaN];
          } else {
            coordinates = [];
          }
        } else {
          switch (geomType) {
            case 'POINT':
              {
                coordinates = this.parsePointText_();
                break;
              }
            case 'LINESTRING':
              {
                coordinates = this.parseLineStringText_();
                break;
              }
            case 'POLYGON':
              {
                coordinates = this.parsePolygonText_();
                break;
              }
            case 'MULTIPOINT':
              {
                coordinates = this.parseMultiPointText_();
                break;
              }
            case 'MULTILINESTRING':
              {
                coordinates = this.parseMultiLineStringText_();
                break;
              }
            case 'MULTIPOLYGON':
              {
                coordinates = this.parseMultiPolygonText_();
                break;
              }
            default:
              break;
          }
        }
        return new ctor(coordinates, this.layout_);
      }
      throw new Error(this.formatErrorMessage_());
    }
  }]);
}();
/**
 * @classdesc
 * Geometry format for reading and writing data in the `WellKnownText` (WKT)
 * format.
 *
 * @api
 */
var WKT = /*#__PURE__*/function (_TextFeature) {
  /**
   * @param {Options} [options] Options.
   */
  function WKT(options) {
    var _this;
    _classCallCheck(this, WKT);
    _this = _callSuper(this, WKT);
    options = options ? options : {};

    /**
     * Split GeometryCollection into multiple features.
     * @type {boolean}
     * @private
     */
    _this.splitCollection_ = options.splitCollection !== undefined ? options.splitCollection : false;
    return _this;
  }

  /**
   * Parse a WKT string.
   * @param {string} wkt WKT string.
   * @return {import("../geom/Geometry.js").default}
   *     The geometry created.
   * @private
   */
  _inherits(WKT, _TextFeature);
  return _createClass(WKT, [{
    key: "parse_",
    value: function parse_(wkt) {
      var lexer = new Lexer(wkt);
      var parser = new Parser(lexer);
      return parser.parse();
    }

    /**
     * @protected
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [options] Read options.
     * @return {import("../Feature.js").default} Feature.
     */
  }, {
    key: "readFeatureFromText",
    value: function readFeatureFromText(text, options) {
      var geom = this.readGeometryFromText(text, options);
      var feature = new Feature();
      feature.setGeometry(geom);
      return feature;
    }

    /**
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [options] Read options.
     * @protected
     * @return {Array<Feature>} Features.
     */
  }, {
    key: "readFeaturesFromText",
    value: function readFeaturesFromText(text, options) {
      var geometries = [];
      var geometry = this.readGeometryFromText(text, options);
      if (this.splitCollection_ && geometry.getType() == 'GeometryCollection') {
        geometries = /** @type {GeometryCollection} */geometry.getGeometriesArray();
      } else {
        geometries = [geometry];
      }
      var features = [];
      for (var i = 0, ii = geometries.length; i < ii; ++i) {
        var feature = new Feature();
        feature.setGeometry(geometries[i]);
        features.push(feature);
      }
      return features;
    }

    /**
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [options] Read options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */
  }, {
    key: "readGeometryFromText",
    value: function readGeometryFromText(text, options) {
      var geometry = this.parse_(text);
      return transformGeometryWithOptions(geometry, false, options);
    }

    /**
     * @param {import("../Feature.js").default} feature Features.
     * @param {import("./Feature.js").WriteOptions} [options] Write options.
     * @protected
     * @return {string} Text.
     */
  }, {
    key: "writeFeatureText",
    value: function writeFeatureText(feature, options) {
      var geometry = feature.getGeometry();
      if (geometry) {
        return this.writeGeometryText(geometry, options);
      }
      return '';
    }

    /**
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [options] Write options.
     * @protected
     * @return {string} Text.
     */
  }, {
    key: "writeFeaturesText",
    value: function writeFeaturesText(features, options) {
      if (features.length == 1) {
        return this.writeFeatureText(features[0], options);
      }
      var geometries = [];
      for (var i = 0, ii = features.length; i < ii; ++i) {
        geometries.push(features[i].getGeometry());
      }
      var collection = new GeometryCollection(geometries);
      return this.writeGeometryText(collection, options);
    }

    /**
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [options] Write options.
     * @protected
     * @return {string} Text.
     */
  }, {
    key: "writeGeometryText",
    value: function writeGeometryText(geometry, options) {
      return encode(transformGeometryWithOptions(geometry, true, options));
    }
  }]);
}(TextFeature);
/**
 * @param {Point} geom Point geometry.
 * @return {string} Coordinates part of Point as WKT.
 */
function encodePointGeometry(geom) {
  var coordinates = geom.getCoordinates();
  if (coordinates.length === 0) {
    return '';
  }
  return coordinates.join(' ');
}

/**
 * @param {MultiPoint} geom MultiPoint geometry.
 * @return {string} Coordinates part of MultiPoint as WKT.
 */
function encodeMultiPointGeometry(geom) {
  var array = [];
  var components = geom.getPoints();
  for (var i = 0, ii = components.length; i < ii; ++i) {
    array.push('(' + encodePointGeometry(components[i]) + ')');
  }
  return array.join(',');
}

/**
 * @param {GeometryCollection} geom GeometryCollection geometry.
 * @return {string} Coordinates part of GeometryCollection as WKT.
 */
function encodeGeometryCollectionGeometry(geom) {
  var array = [];
  var geoms = geom.getGeometries();
  for (var i = 0, ii = geoms.length; i < ii; ++i) {
    array.push(encode(geoms[i]));
  }
  return array.join(',');
}

/**
 * @param {LineString|import("../geom/LinearRing.js").default} geom LineString geometry.
 * @return {string} Coordinates part of LineString as WKT.
 */
function encodeLineStringGeometry(geom) {
  var coordinates = geom.getCoordinates();
  var array = [];
  for (var i = 0, ii = coordinates.length; i < ii; ++i) {
    array.push(coordinates[i].join(' '));
  }
  return array.join(',');
}

/**
 * @param {MultiLineString} geom MultiLineString geometry.
 * @return {string} Coordinates part of MultiLineString as WKT.
 */
function encodeMultiLineStringGeometry(geom) {
  var array = [];
  var components = geom.getLineStrings();
  for (var i = 0, ii = components.length; i < ii; ++i) {
    array.push('(' + encodeLineStringGeometry(components[i]) + ')');
  }
  return array.join(',');
}

/**
 * @param {Polygon} geom Polygon geometry.
 * @return {string} Coordinates part of Polygon as WKT.
 */
function encodePolygonGeometry(geom) {
  var array = [];
  var rings = geom.getLinearRings();
  for (var i = 0, ii = rings.length; i < ii; ++i) {
    array.push('(' + encodeLineStringGeometry(rings[i]) + ')');
  }
  return array.join(',');
}

/**
 * @param {MultiPolygon} geom MultiPolygon geometry.
 * @return {string} Coordinates part of MultiPolygon as WKT.
 */
function encodeMultiPolygonGeometry(geom) {
  var array = [];
  var components = geom.getPolygons();
  for (var i = 0, ii = components.length; i < ii; ++i) {
    array.push('(' + encodePolygonGeometry(components[i]) + ')');
  }
  return array.join(',');
}

/**
 * @param {import("../geom/SimpleGeometry.js").default} geom SimpleGeometry geometry.
 * @return {string} Potential dimensional information for WKT type.
 */
function encodeGeometryLayout(geom) {
  var layout = geom.getLayout();
  var dimInfo = '';
  if (layout === 'XYZ' || layout === 'XYZM') {
    dimInfo += Z;
  }
  if (layout === 'XYM' || layout === 'XYZM') {
    dimInfo += M;
  }
  return dimInfo;
}

/**
 * @const
 * @type {Object<string, function(import("../geom/Geometry.js").default): string>}
 */
var GeometryEncoder = {
  'Point': encodePointGeometry,
  'LineString': encodeLineStringGeometry,
  'Polygon': encodePolygonGeometry,
  'MultiPoint': encodeMultiPointGeometry,
  'MultiLineString': encodeMultiLineStringGeometry,
  'MultiPolygon': encodeMultiPolygonGeometry,
  'GeometryCollection': encodeGeometryCollectionGeometry
};

/**
 * Encode a geometry as WKT.
 * @param {import("../geom/Geometry.js").default} geom The geometry to encode.
 * @return {string} WKT string for the geometry.
 */
function encode(geom) {
  var type = geom.getType();
  var geometryEncoder = GeometryEncoder[type];
  var enc = geometryEncoder(geom);
  var wktType = wktTypeLookup[type];
  if (typeof (/** @type {?} */geom.getFlatCoordinates) === 'function') {
    var dimInfo = encodeGeometryLayout(/** @type {import("../geom/SimpleGeometry.js").default} */geom);
    if (dimInfo.length > 0) {
      wktType += ' ' + dimInfo;
    }
  }
  if (enc.length === 0) {
    return wktType + ' ' + EMPTY;
  }
  return wktType + '(' + enc + ')';
}
export default WKT;